module.exports = __webpack_public_path__ + "static/media/subaru-impreza-gj.7491f910.jpg";